import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VDialog,{attrs:{"scrollable":"","persistent":""},model:{value:(_vm.isDialogOpen),callback:function ($$v) {_vm.isDialogOpen=$$v},expression:"isDialogOpen"}},[_c(VCard,[_c(VCardTitle,[_c('span',{staticClass:"headline"},[_vm._t("title")],2)]),_c(VCardText,[_vm._t("body")],2),_c(VCardActions,[_vm._t("footer")],2)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }